import appApi from '../../../../api/app-api';
import { toast } from 'react-toastify';

const toYyyyMmDd = (date: Date) => {
  const d = new Date(date);
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

export const paySalaryForProfessorFlatOperation = async (
  branchId: number | null,
  dateRangeStart: Date | null,
  dateRangeEnd: Date | null,
  professorIds: number[],
  setLoading: (loading: boolean) => void,
): Promise<boolean> => {
  try {
    if (!branchId || branchId < 1) {
      toast.warn('יש לבחור שלוחה');
      return false;
    }
    if (!dateRangeStart || !dateRangeEnd) {
      toast.warn('יש לבחור טווח תאריכים');
      return false;
    }
    if (dateRangeStart > dateRangeEnd) {
      toast.warn('תאריך ההתחלה חייב להיות לפני תאריך הסיום');
      return false;
    }
    if (professorIds.length === 0) {
      toast.warn('יש לבחור לפחות מרצה אחד');
      return false;
    }
    setLoading(true);
    await appApi.createProfessorPayrollFromPending(
      branchId,
      toYyyyMmDd(dateRangeStart),
      toYyyyMmDd(dateRangeEnd),
      professorIds,
    );
    setLoading(false);

    toast.success('התשלום התבצע בהצלחה!');
    return true;
  } catch (e) {
    setLoading(false);
    toast.error('שגיאה באישור התשלום, נסה שוב בעוד מספר רגעים...');
    return false;
  }
};
